export default __webpack_public_path__ + "static/media/21.2c4bc7e2.jpg";